angular.module('elfium').filter('elfiumDaterangeTwo', function () {
	var that = this;
	that.hasDateFilters = function (dateFilters) {
		var has = false;
		for (var keyX in dateFilters) {
			for (var keyY in dateFilters[keyX]) {
				if (dateFilters[keyX][keyY].startDate || dateFilters[keyX][keyY].endDate) {
					has = true;
					break;
				}
			}
		}
		return has;
	};
    return function (objectList, dateFilters) {
        var resultList = [];
        if (that.hasDateFilters(dateFilters)) {
        	angular.forEach(dateFilters, function (filterA, fieldNameA) {
        		angular.forEach(filterA, function (filterB, fieldNameB) {
		        	angular.forEach(objectList, function (currentObject) {
		        		if (currentObject && currentObject[fieldNameA] && currentObject[fieldNameA][fieldNameB] && moment(currentObject[fieldNameA][fieldNameB]).isBetween(filterB.startDate, filterB.endDate, null, '[]')) {
		        			resultList.push(currentObject);
		        		}
		        	});
		        });
	        });	
        } else {
        	resultList = objectList;
        }        
        return resultList;
    }
});


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumDaterangeTwo.ts